// extracted by mini-css-extract-plugin
export default {"table":"table_table__UP7Vx","isBox":"table_isBox__I0JWO","is4Columns":"table_is4Columns__HOh9d","is5Columns":"table_is5Columns__9sYQ1","is6Columns":"table_is6Columns__ZFVcZ"};